export default "__VITE_ASSET__BtwUjHqh__"